module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elAppleQRcode_151415.f3f1cb52.jpg";